// src/components/MonoButton.jsx
import React from "react";
import UnderlineSketch from "./UnderlineSketch";

const MonoButtonSmall = ({ type = "button", onClick, children, className = "" }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`relative group inline-block font-mono border border-black text-gray-800 bg-brand py-0 mt-1 px-2 rounded-md overflow-hidden ${className}`}
    >
      <span className="flex items-center justify-center space-x-2">
        <span className="inline-block transform transition-transform duration-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0">
          →
        </span>
        <span className="relative z-10">{children}</span>
      </span>
      {/* Ersetze statische Linie mit animierter Skizzenlinie */}
     
    </button>
  );
};

export default MonoButtonSmall;